export const CheckIconLaunch = (props) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.1667 6.01222V6.50289C12.1661 7.65298 11.7983 8.77205 11.1183 9.69319C10.4383 10.6143 9.48241 11.2882 8.3933 11.6143C7.30418 11.9404 6.14015 11.9012 5.07481 11.5027C4.00947 11.1041 3.09989 10.3675 2.48175 9.40266C1.8636 8.43784 1.56999 7.29652 1.64472 6.14892C1.71944 5.00132 2.1585 3.90893 2.8964 3.03466C3.63431 2.16039 4.63152 1.55109 5.73932 1.29763C6.84712 1.04418 8.00615 1.16014 9.04355 1.62822M12.1667 2.23317L6.9 7.57183L5.31999 5.97184"
        stroke="#1ECB4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
